export const blockIconsMapsDirectionsCar = (
	<span className='material-symbols-outlined'>directions_car</span>
);
